import { Location } from '@angular/common';
import { Component, ElementRef, OnInit, Renderer, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
//import { ITreeOptions, KEYS, TreeModel, TREE_ACTIONS } from "angular-tree-component/dist/angular-tree-component";
//import { TreeComponent } from "angular-tree-component/dist/components/tree.component";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { CookieService } from 'ngx-cookie-service';

import { AppWideUser, Token } from "../Services/AppUserProfile";

import { UserService } from "../Services/user.service";
import { ROUTES } from '../sidebar/sidebar-routes.config';
import { Globals } from '../Models/UserProfile.model';


var misc: any = {
    navbar_menu_visible: 0,
    active_collapse: true,
    disabled_collapse_init: 0,
}
declare var $: any;

@Component({
    moduleId: module.id,
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css'],
    encapsulation: ViewEncapsulation.None,
    providers: [UserService]
})

export class NavbarComponent implements OnInit {
    impersonationStatus:boolean;
    loginUserId:number;
    private listTitles: any[];
    keyword: string;
    location: Location;
    private nativeElement: Node;
    private toggleButton;
    private sidebarVisible: boolean;
    companyId: number;
    showMessage: boolean;
    changeSite: number;
    @ViewChild("navbar-cmp") button;
    @ViewChild("nav") sidebarComp: ElementRef;
    index: number;
    nodes: any;
    message: string;
    interval: any;
    role: string;
    isAuthorizedToChangeSite: boolean;
    userName: string;

    companyName: string;
    changeSiteName: string;
    changeSiteId: number;

    hierarchy: any[];
    showCompanyName: true;

    isUserAccessConfig: boolean;



    levelNumber;
    public loading = false;
   
    constructor(private userService: UserService, private spinnerService: Ng4LoadingSpinnerService, private cookieService: CookieService, location: Location, private appUserDetails: AppWideUser, private renderer: Renderer, private element: ElementRef, private router: Router, private constlocation: Location, private token: Token) {

        if (this.appUserDetails.UserName == undefined && this.token.access_token == undefined || this.appUserDetails.UserName == null && this.token.access_token == null) {
            this.appUserDetails = JSON.parse(this.cookieService.get('AppWideUser'));
            this.token = JSON.parse(this.cookieService.get('Token'));
        }
        this.userName = this.appUserDetails.UserName;
        
        this.impersonationStatus = Globals.ImpersonationValue;
        this.loginUserId = this.appUserDetails.UserId;

        this.isUserAccessConfig = false;

        this.location = location;
        this.nativeElement = element.nativeElement;
        this.sidebarVisible = false;
       

    }


    ngAfterViewInit() {
        
    }








    NavigateToChangePassword() {
        //this.router.navigate(['change-password']);
    }

    filterNodes(text, tree) {
        tree.treeModel.filterNodes(text, true);
    };
    

    SignOut() {
        this.router.navigate(["login"]);
        this.constlocation.replaceState('/');
        window.document.cookie.split(";").forEach(function (c) {
            document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
        });
        this.appUserDetails = null;
        this.token.access_token = null;
        this.token.userName = null;
        this.token.expires_in = null;
        this.token.token_type = null;
        //====================Impersonation==============>
        //this.appUserDetails.UserId =1;
        //this.loginUserId = this.appUserDetails.UserId;
        Globals.ImpersonationValue = false;
        this.impersonationStatus = Globals.ImpersonationValue; 
        //<===============================================
    }

    ngOnInit() {
        $('.selectpicker').selectpicker({
            style: 'btn-info',
            size: 4
        });

        this.listTitles = ROUTES.filter(listTitle => listTitle);
        var navbar: HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];
        if ($('body').hasClass('sidebar-mini')) {
            misc.sidebar_mini_active = true;
        }
        $("#ccpLogo2").hide();
        $('#minimizeSidebar').click(function () {
            var $btn = $(this);
            if (misc.sidebar_mini_active == true) {
                $('body').removeClass('sidebar-mini');
                misc.sidebar_mini_active = false;
                $("#ccpLogo2").hide();
                $("#ccpLogo1").show();
            }
            else {
                setTimeout(function () {
                    $('body').addClass('sidebar-mini');
                    $("#ccpLogo1").hide();
                    $("#ccpLogo2").show();
                    misc.sidebar_mini_active = true;
                }, 300);
            }

            // we simulate the window Resize so the charts will get updated in realtime.
            var simulateWindowResize = setInterval(function () {
                window.dispatchEvent(new Event('resize'));
            }, 180);

            // we stop the simulation of Window Resize after the animations are completed
            setTimeout(function () {
                clearInterval(simulateWindowResize);
            }, 1000);
        });

        $(".clearFilter").click(function () {
            $('.filter').find('input:text').val('');
        });
    }

    isMobileMenu() {
        if ($(window).width() > 767 && $(window).width() < 1000) {
            return true;

        }
        return false;
    }

    ShowChangeSite() {
        if ($(window).width() < 500) {
            return true;

        }
        else {
            return false;
        }
    }

    sidebarToggle() {
        var toggleButton = this.toggleButton;
        var body = document.getElementsByTagName('body')[0];
        if (this.sidebarVisible == false) {
            setTimeout(function () {
                toggleButton.classList.add('toggled');
            }, 500);
            body.classList.add('nav-open');
            this.sidebarVisible = true;
        } else {
            this.toggleButton.classList.remove('toggled');
            this.sidebarVisible = false;
            body.classList.remove('nav-open');
        }
    }



    getTitle() {
        var titlee = this.location.prepareExternalUrl(this.location.path());
        if (titlee.charAt(0) === '#') {
            titlee = titlee.slice(2);
        }
        for (var item = 0; item < this.listTitles.length; item++) {
            if (this.listTitles[item].path === titlee) {
                return this.listTitles[item].title;
            }
        }
        return 'Dashboard';
    }
    getPath() {
        return this.location.prepareExternalUrl(this.location.path());
    }
}
function fuzzysearch(needle, haystack) {
    const haystackLC = haystack.toLowerCase();
    const needleLC = needle.toLowerCase();

    const hlen = haystack.length;
    const nlen = needleLC.length;

    if (nlen > hlen) {
        return false;
    }
    if (nlen === hlen) {
        return needleLC === haystackLC;
    }
    outer: for (let i = 0, j = 0; i < nlen; i++) {
        const nch = needleLC.charCodeAt(i);

        while (j < hlen) {
            if (haystackLC.charCodeAt(j++) === nch) {
                continue outer;
            }
        }
        return false;
    }
    return true;
}
export const GlobalVariable = Object.freeze({

});


// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/navbar/navbar.component.ts